var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center h-full"},[_c('vs-button',{attrs:{"color":"primary","type":"filled","icon-pack":"feather","icon":"icon-edit"},on:{"click":_vm.editData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }